export default {
    // 模块名称
    carPatrol: {
        // 按钮类
        button: {
            create: 'Create',
            delete: 'Delete',
            start: 'Enabled',
            disable: 'Disabled',
            query: 'Query',
            reset: 'Reset',
            confirm: 'Confirm',
            cancel: 'Cancel',
            back: 'Back',
            Enabled: 'Enabled',
            Disabled: 'Disabled',
            limit: 'Limit',
            submit: 'Submit'
        },
        // 文字标签类
        label: {
            name:'Name',
            state:'Status',
            time:'Time',
            people:'People',
            type:'Type',
            groups:'NameGroups',
            blacklist:'Blacklist',
            timeQuantum:'Period',
            select:'Select',
            number:'Number',
            blacklistName:'BlacklistName',
            cameraGroups: 'CameraGroups',
            carList: 'CarListDetails',
            carer: 'Owner',
            carNo: 'CarNo',
            carType: 'CarType',
            carColor: 'CarColor',
            nodata: 'No Data',
            to: ' To ',
            blackGroup: 'Blacklist group',
            week: 'Week',
            oneDay: 'Monday',
            twoDay: 'Tuesday',
            threeDay: 'Wednesday',
            fourDay: 'Thursday',
            fiveDay: 'Friday',
            satDay: 'Saturday',
            sunDay: 'Sunday'
        },
        // 提示类
        placeholder: {
            modification: 'Edit',
            delete: 'Delete',
            disable: 'Disabled',
            details:'Details',
            enabled:'Enabled',
            name:'Enter control name',
            state:'Select control status',
            unlimited:'Unlimited',
            blackGroup:'Enter the name of the blacklist group',
            chooseBlack:'Select blacklist',
            chooseTime:'Select the time of the control',
            length:'1 to 50 characters in length',
            nameIno:'The name of the control is illegal and should be a combination of Chinese, English and numbers.'
        },
        // 消息类
        message: {
            unableDelete:'Task enabled, cannot be deleted',
            deleteWarn:'This action permanently deletes the task. Do you want to continue?',
            deleteOk:'Delete successully',
            deleteNo:'Delete failed',
            deleteStarting:'The selected task has an enabled task and cannot be deleted!',
            startWarn:'This operation will enable the deployment task. Do you want to continue?',
            disableWarn:'This operation will disable the deployment task. Do you want to continue?',
            starting:'The selected task has enabled tasks!',
            disableing:'The selected task has disabled tasks!',
            someStart:'This operation will batch enable the task. Do you want to continue?',
            someDisable:'This action disables the task in bulk. Do you want to continue?',
            someDelete:'This action will batch delete the task. Do you want to continue?',
            batchStart:'You have not selected the deployment task to enable in bulk', //批量启用提醒
            batchDisable:'You have not selected a deployment task to disable in bulk', //批量禁用提醒
            batchDelete:'You have not selected the deployment task to be deleted in bulk', //批量删除提醒
            name: 'Please enter layout control name',
            blacklistName: 'Please select blacklist group',
            timeQuantum: 'Please select control time'
        },
        // 标题类
        title: {
            remind:'Warning',
            cancel:'Cancel',
            successStart:'Start success',
            successDisable:'Disable success',
            blackList:'Black list Select',
            selectGroup:'Selected blacklist group',
            selectCamera:'The selected control camera set',
            lookDetails: 'View Details',
            editControl: 'Edit control',
            ControlTimeSelect: 'Control time selection',
        }
    }
}